import { removeNull, resetAttribute, stripFormerNameSuffix, asRows, attachCreateTime } from '@/utils/handleData.js'

export default {
  namespaced: true,
  state: {
    enterprises: [], // 缓存根据关键词查询到的实体企业名单
    enterpriseList: {}, // 缓存企业信息列表当前页
    enterpriseBaseInfo: {}, // 缓存企业基础信息
    certificate: [], // 缓存企业资质证书
    enterpriseRecord: [], // 缓存企业项目业绩
    attachments: {}, // 缓存企业附件
    entAuthentication: {} // 缓存从天眼查查询的企业基础信息
  },
  actions: {
    // 按照关键词查询实体企业名称及uid
    async getEnterpriseName({ commit, dispatch, rootState }, name) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/companyinfo/query',
          data: { comanyName: name }
        },
        { root: true }
      )
      if (res.data && res.data !== []) {
        const seen = {}
        const enterprises = resetAttribute(
          res.data,
          'companyName',
          'companyUid'
        ).filter((item) => {
          const value = item.companyUid || item.orgUid || item.uid || item.value
          const label = item.companyName || item.label
          if (!value || !label || seen[value]) return false
          seen[value] = true
          item.label = label
          item.value = value
          return true
        })
        const keepUids = {}
        const formBase =
          (rootState.formValues && rootState.formValues.baseInfo) || {}
        const formContract =
          (rootState.formValues && rootState.formValues.contract) || {}
        const detail =
          (rootState.bidSection && rootState.bidSection.bidSectionBaseInfo) ||
          {}
        const contract =
          (rootState.bidSection && rootState.bidSection.bidSectionContract) ||
          {}
        ;[
          formBase.parentCompanyUid || detail.parentCompanyUid,
          formContract.contractCompanyUid || contract.contractCompanyUid
        ].forEach((uid) => {
          if (uid) keepUids[String(uid)] = true
        })
        const previous = Array.isArray(rootState.enterprise.enterprises)
          ? rootState.enterprise.enterprises
          : []
        previous.forEach((item) => {
          if (
            item &&
            keepUids[String(item.value)] &&
            !enterprises.some((row) => String(row.value) === String(item.value))
          ) {
            enterprises.unshift(item)
          }
        })
        commit(
          'baseSet',
          { module: 'enterprise', key: 'enterprises', value: enterprises },
          { root: true }
        )
      } else {
        const previous = Array.isArray(rootState.enterprise.enterprises)
          ? rootState.enterprise.enterprises.filter((item) => item && item.value)
          : []
        commit(
          'baseSet',
          { module: 'enterprise', key: 'enterprises', value: previous },
          { root: true }
        )
      }
    },
    // 按照企业名称全称从天眼查查询认证企业信息
    async queryEnterprise({ commit, dispatch }, name) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/company/returninfo',
          data: { orgName: name }
        },
        { root: true }
      )
      if (res.data && res.data !== []) {
        commit(
          'baseSet',
          { module: 'enterprise', key: 'entAuthentication', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'enterprise', key: 'entAuthentication', value: {} },
          { root: true }
        )
      }
    },
    // 新增企业档案基础信息
    async addEnterprise({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fixed/companyinfo',
          data: data,
          msg: true
        },
        { root: true }
      )
      if (res.data && res.data.uid) {
        commit(
          'currentUidsSet',
          {
            key: 'enterprise',
            value: res.data.uid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'baseInfo',
            value: res.data.uid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'attachment',
            value: res.data.uid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'certificate',
            value: res.data.uid
          },
          { root: true }
        )
      }
      return res
    },
    // 新增企业资质证书
    async addCertificate({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fixed/certificate',
          data: data,
          msg: '新增企业资质证书成功'
        },
        { root: true }
      )
      return res
    },
    // 删除企业档案
    async deleteEnterprise({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fixed/companyinfo',
          data: { uid: uid },
          msg: '删除企业档案成功'
        },
        { root: true }
      )
      return res
    },
    // 删除企业资质证书
    async deleteCertificate({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fixed/certificate',
          data: { uid: uid },
          msg: '删除企业资质证书成功'
        },
        { root: true }
      )
      return res
    },
    // 获取企业列表
    async getEnterpriseList({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.enterprise
      queryValues.page = rootState.page.enterprise
      queryValues.limit = rootState.limit.enterprise
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/fixed/companyinfo/list', data: queryValues },
        { root: true }
      )
      if (res.data) {
        const enterpriseList = res.data
        if (enterpriseList.result && enterpriseList.result.length) {
          enterpriseList.result.forEach((item) => {
            item.qcodeInfo = {
              qcodeUrl: item.qcode || item.orgUid,
              qcodeName: item.orgName,
              project: '',
              leftText: '用诚信企业',
              rightText: '干品质工程'
            }
            item.orgName = stripFormerNameSuffix(item.orgName)
          })
        }
        commit(
          'baseSet',
          { module: 'enterprise', key: 'enterpriseList', value: enterpriseList },
          { root: true }
        )
      }
    },
    // 查询单个企业全部信息
    async getEnterpriseInfo({ rootState, dispatch }, uid) {
      const pageName = rootState.currentStep.step.slice(0, -4)
      const enterpriseUid = uid ? uid : rootState.currentUids[pageName]
      const enterpriseBaseInfo = await dispatch(
        'getEnterpriseBaseInfo',
        enterpriseUid
      )
      const certificate = await dispatch('getCertificates', enterpriseUid)
      const enterpriseRecord = await dispatch(
        'getEnterpriseRecords',
        enterpriseUid
      )
      const attachments = await dispatch(
        'getEnterpriseAttachment',
        enterpriseUid
      )
      const enterpriseInfo = {
        baseInfo: enterpriseBaseInfo,
        certificate: certificate,
        attachment: attachments,
        enterpriseRecord: enterpriseRecord,
        qcodeInfo: enterpriseBaseInfo.qcodeInfo
      }
      return enterpriseInfo
    },
    // 管理权限外用户查看企业部分信息
    async checkEnterpriseInfo({ rootState, dispatch }, uid) {
      const pageName = rootState.currentStep.step.slice(0, -4)
      const enterpriseUid = uid ? uid : rootState.currentUids[pageName]
      const enterpriseBaseInfo = await dispatch(
        'getEnterpriseBaseInfo',
        enterpriseUid
      )
      const certificate = await dispatch('getCertificates', enterpriseUid)
      const enterpriseRecord = await dispatch(
        'getEnterpriseRecords',
        enterpriseUid
      )
      const enterpriseInfo = {
        baseInfo: enterpriseBaseInfo,
        certificate: certificate,
        enterpriseRecord: enterpriseRecord
      }
      return enterpriseInfo
    },
    // 查询单个企业基础信息
    async getEnterpriseBaseInfo({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/companyinfo/detail',
          data: { orgUid: uid }
        },
        { root: true }
      )
      var raw = res.data
      var enterpriseBaseInfo = Array.isArray(raw) ? raw[0] || {} : raw || {}
      enterpriseBaseInfo.uid = uid
      enterpriseBaseInfo.formerName = enterpriseBaseInfo.formerName || ''
      enterpriseBaseInfo.name = enterpriseBaseInfo.orgName
      enterpriseBaseInfo.parentEnterprise = enterpriseBaseInfo.parentCompany
      enterpriseBaseInfo.parentCompany = enterpriseBaseInfo.parentCompanyUid
      enterpriseBaseInfo.establishmentDate = enterpriseBaseInfo.orgBeginTime
      enterpriseBaseInfo.qcodeInfo = {
        qcodeUrl: enterpriseBaseInfo.qcode || uid,
        qcodeName: enterpriseBaseInfo.name,
        project: '',
        leftText: '用诚信企业',
        rightText: '干品质工程'
      }
      commit(
        'baseSet',
        {
          module: 'enterprise',
          key: 'enterpriseBaseInfo',
          value: enterpriseBaseInfo
        },
        { root: true }
      )
      return enterpriseBaseInfo
    },
    // 查询单个企业资质证书
    async getCertificates({ rootState, commit, dispatch }, uid) {
      const orgUid =
        rootState.currentUids.enterprise ||
        uid ||
        rootState.currentUids.baseInfo ||
        ''
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/company/certificate',
          data: { orgUid: orgUid }
        },
        { root: true }
      )
      var certificate = asRows(res && res.data)
      certificate.forEach((item, index) => {
        if (!item) return
        attachCreateTime(item)
        item.uid = item.uid || item.UID
        item.companyUid =
          item.companyUid || item.companyuid || item.company_uid || orgUid
        item.certificateName =
          item.certificateName ||
          item.certificatename ||
          item.certificate_name ||
          ''
        item.certificateType =
          item.certificateType ||
          item.certificatetype ||
          item.certificate_type ||
          ''
        item.certificateNum =
          item.certificateNum ||
          item.certificatenum ||
          item.certificate_num ||
          ''
        item.certificateStatus =
          item.certificateStatus ||
          item.certificatestatus ||
          item.certificate_status ||
          ''
        item.photoUid =
          item.photoUid || item.photouid || item.photo_uid || ''
        if (item.certificateStatus === '有效') {
          item.statusIcon = 'el-icon-circle-check'
        } else {
          item.statusIcon = 'el-icon-circle-close'
        }
        item.fileLists = {}
        const key = 'certificate' + (index + 1)
        commit(
          'pictureSet',
          { key: key, value: item.photoUid ? [item.photoUid] : [] },
          { root: true }
        )
        item.fileLists.photoUid = rootState.pictures[key] || []
      })
      commit(
        'baseSet',
        { module: 'enterprise', key: 'certificate', value: certificate },
        { root: true }
      )
      return certificate
    },
    // 查询单个企业项目业绩
    async getEnterpriseRecords({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/company/projectrecord',
          data: { orgUid: uid }
        },
        { root: true }
      )
      // console.log(res)
      var enterpriseRecord = asRows(res && res.data)
      enterpriseRecord.forEach((item) => {
        if (item.walkoffDate) {
          item.titleText =
            item.orgBeginTime +
            '\xa0\xa0\xa0—\xa0\xa0\xa0' +
            item.walkoffDate +
            '\xa0\xa0\xa0\xa0\xa0\xa0' +
            item.orgName
        } else {
          item.titleText =
            item.orgBeginTime +
            '\xa0\xa0\xa0—\xa0\xa0\xa0' +
            '至今' +
            '\xa0\xa0\xa0\xa0\xa0\xa0' +
            item.orgName
        }
        item.typeIcon = 'el-icon-set-up'
        item.maxUserNum = item.maxUserNum + ''
      })
      commit(
        'baseSet',
        {
          module: 'enterprise',
          key: 'enterpriseRecord',
          value: enterpriseRecord
        },
        { root: true }
      )
      return enterpriseRecord
    },
    // 查询单个企业附件信息
    async getEnterpriseAttachment({ rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/companyinfo/detail',
          data: { orgUid: uid }
        },
        { root: true }
      )
      var raw = res.data
      var attachments = Array.isArray(raw) ? raw[0] || {} : raw || {}
      attachments.uid = uid
      attachments.businessPerfUid = attachments.businessPhoto
      if (Array.isArray(attachments.otherPhoto)) {
        attachments.otherPhoto = attachments.otherPhoto.filter(Boolean)
      } else if (attachments.otherPhoto) {
        attachments.otherPhoto = String(attachments.otherPhoto)
          .replace(/[[\]\s]/g, '')
          .split(',')
          .filter(Boolean)
      } else {
        attachments.otherPhoto = []
      }
      commit(
        'pictureSet',
        { key: 'businessPerfUid', value: attachments.businessPerfUid ? [attachments.businessPerfUid] : [] },
        { root: true }
      )
      commit(
        'pictureSet',
        { key: 'safeProductPhoto', value: attachments.safeProductPhoto ? [attachments.safeProductPhoto] : [] },
        { root: true }
      )
      commit(
        'pictureSet',
        { key: 'otherPhoto', value: attachments.otherPhoto },
        { root: true }
      )
      attachments.fileLists = {
        businessPerfUid: rootState.pictures.businessPerfUid,
        safeProductPhoto: rootState.pictures.safeProductPhoto,
        otherPhoto: rootState.pictures.otherPhoto
      }
      commit(
        'baseSet',
        { module: 'enterprise', key: 'attachments', value: attachments },
        { root: true }
      )
      return attachments
    },
    // 编辑企业档案基础信息及附件信息
    async editEnterprise({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/companyinfo',
          data: data,
          msg: '编辑企业档案成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑企业档案资质证书
    async editCertificate({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/certificate',
          data: data,
          msg: '编辑企业资质证书成功'
        },
        { root: true }
      )
      return res
    }
  }
}
